import React from 'react'
import { Col, Container, Row } from '@paypalcorp/pp-react'

import styles from './YouTubeColumnLayout.module.css'
import YoutubeVideo from '../YoutubeVideo/YoutubeVideo'

const YouTubeColumnLayout = ({
  children,
  youtubeEmbedUrl,
  youtubeTitle,
  contentRight = false,
}: any) => {
  return (
    <Container>
      <Row>
        {!contentRight && (
          <Col md={6} xs={12}>
            {children}
          </Col>
        )}
        <Col md={6} xs={12} className={styles.videoWrapper}>
          <YoutubeVideo embedUrl={youtubeEmbedUrl} title={youtubeTitle} />
        </Col>
        {contentRight && (
          <Col md={6} xs={12}>
            {children}
          </Col>
        )}
      </Row>
    </Container>
  )
}

export default YouTubeColumnLayout
